<template>
  <div>
    <v-card>
      <v-card-title>
        
        <span v-if="$store.getters.smediasIsEdit"> ویرایش شبکه اجتمائی</span>
        <span v-else> افزودن شبکه اجتمائی جدید</span>
      </v-card-title>
      <v-divider> </v-divider>
      <v-card-text>
        <v-form ref="smediaForm" v-model="smediaValid">
          <v-row>
            <v-col cols="12" md="4">
              <v-combobox
                deletable-chips
                v-model="selectedSocislMedia"
                hide-selected
                label="* شبکه اجتماعی مورد نظر"
                item-text="title"
                item-value="id"
                persistent-hint
                small-chips
                outlined
                dense
                clearable
                flat
                hide-no-data
                :items="socialMediaItems"
                :loading="socialmediasLoading"
              >
              </v-combobox>
            </v-col>
         
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-textarea
                label=" شناسه کاربری "
                prepend-icon="mdi-comment"
                rows="2"
                row-height="20"
                outlined
                dense
                v-model="merchantSocialmedia.membershipId"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer> </v-spacer>
        <v-btn color="error" @click="closeForm()">انصراف</v-btn>
        <v-btn  color="primary" @click="save()"> ذخیره </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
 

const merchantRepository = () => RepoFactory.get('merchant');
import Helper from '@/core/helpers';

export default {
  components: {
   // socialMediaItems: [],
  },
  data() {
    return {
      selectedSocislMedia: null,
 
      smediaValid: true,
      socialmediasLoading: false,
      socialMediaItems: [],
      vendorGroupItems: [],
      merchantSocialmedia: {
        socialMediaId: null,
        membershipId: '',
      },
    };
  },
  computed: {
    merchantBaseUrl() {
      return this.$store.getters.merchantBaseUrl;
    },
  },
  created() {
    if (this.$store.getters.smediasIsEdit) {
      this.fillInput(this.$store.getters.smediasSelectedForEdit);
    }
      //Get Social media list to select
      this.getGeneralSocialMediaList();
  },
  watch: {

  },
  methods: {
    fillInput(data) {
 
      if (data) {
        const loader = this.$loading.show();
        merchantRepository()
          .getVendorById(data.id, this.merchantBaseUrl, )
          .then((res) => {
         
             if (res.data.vendorGroupId) {
              this.selectedVendorGroup={id:res.data.vendorGroupId,title: res.data.vendorGroupTitle}
            }
             else {
              this.selectedVendorGroup=null
            }
            this.selectedSocislMedia = { socialmediaId: res.data.vendorMerchantId, name:res.data.merchantName};
            this.socialMediaItems = [];
            this.socialMediaItems.push({ socialmediaId: res.data.VendorMerchantId, name: res.data.merchantName })
                    this.vendor.VendorPermissionId =res.data.id,
                    this.vendor.VendorMerchantId=res.data.VendorMerchantId
                    this.vendor.Score=res.data.score
                    this.vendor.VendorGroupId =res.data.vendorGroupId
                    this.vendor.Description=res.data.description
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          })
          .finally(() => loader.hide());
      }
    },

    save() {
       if (this.selectedSocislMedia == null) {
        this.$dialog.error({
          text: 'شبکه اجتماعی مورد نظر انتخاب شود',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
        return;
      }
      this.merchantSocialmedia.socialMediaId = this.selectedSocislMedia.id;
      console.log("this.merchantSocialmedia:",this.merchantSocialmedia)
      if (
        this.$refs.smediaForm.validate() &&
        this.$store.getters.currentMerchant
      ) {
        const loader = this.$loading.show();
        if (!this.$store.getters.smediasIsEdit) {
          merchantRepository()
            .createMerchantSmedia(
              this.$store.getters.currentMerchant,
              this.merchantSocialmedia,
              this.merchantBaseUrl
            )
            .then(() => {
              this.$dialog.message.success('با موفقیت ثبت گردید', {
                position: 'top-left',
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        } else {
           merchantRepository()
            .editMerchantSmedia(
              this.$store.getters.smediasSelectedForEdit.id,
              this.$store.getters.currentMerchant,
              this.merchantSocialmedia,
              this.merchantBaseUrl,
            )
            .then(() => {
              this.$dialog.message.success('با موفقیت ویرایش گردید', {
                position: 'top-left',
              });
              this.closeForm();
            })
            .catch((error) => {
              Helper.handleErrors(error, this);
            })
            .finally(() => loader.hide());
        }
      } else {
        this.$dialog.error({
          text: 'وارد کردن موارد ستاره دار الزامی میباشد',
          title: 'خطا',
          persistent: true,
          actions: [
            {
              text: 'بستن',
              color: 'red',
            },
          ],
        });
      }
    },
    closeForm() {
      this.$store.commit('setSmediasSelectedForEdit', null);
      this.$store.commit('setSmediasIsEdit', false);
      this.$store.commit('setSmediasFormStatus', false);
    },
    // getVendorPermission(permissionId) {
    //   const loader = this.$loading.show();
    //   merchantRepository()
    //     .getVendorPermission(permissionId, this.merchantBaseUrl)
    //     .then((res) => {
    //       //console.log('res.data.id:', res.data.id);
    //       this.$store.commit('setVendorPermissionId', res.data.id);
    //     })
    //     .catch((err) => {
    //       Helper.handleErrors(err, this);
    //     })
    //     .finally(() => loader.hide());
    // },
    getGeneralSocialMediaList() {
      const loader = this.$loading.show();
      merchantRepository()
        .getGeneralSmediaList(
          this.merchantBaseUrl,
          {},
        )
        .then((res) => {
          console.log('res for General Smedia List:', res.data);
          this.socialMediaItems = [];
          this.socialMediaItems = res.data;
        })
        .catch((error) => {
          Helper.handleErrors(error, this);
        })
        .finally(() => loader.hide());
    },
  },
};
</script>

<style lang="scss" scoped></style>
